import React from "react";
import { Input, notification } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { useData } from "../contexts/DataContext";
import { subscribeUser } from "../services/ApiService";

interface Props {
  caller: "form" | "footer";
}

const SubscribeForm: React.FC<Props> = (caller) => {
  const { state, dispatch } = useData();
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleSubscribe = (email: string) => {
    // Accessing the data context passed as a parameter

    // Disable the form after submission
    dispatch({ type: "SET_SUBSCRIBE_COMPLETED", payload: true });
    const isValidEmail = emailRegex.test(email);
    if (isValidEmail) {
      // Call the subscribeUser function with the entered email value
      subscribeUser(email).then((response) => {
        if (response === true) {
          notification.success({
            message: "Subscription Successful!",
            description: `Thank you for subscribing!\n Email subcribed: ${email}`,
            placement: state.isMobile ? "bottom" : "topRight",
          });

        } else if (response === 'This email has already been registered.') {
          notification.warning({
            message: "Subscription failed!",
            description: `This email has already been registered. \nEmail: ${email}`,
            placement: state.isMobile ? "bottom" : "topRight",
          });

          dispatch({ type: "SET_SUBSCRIBE_COMPLETED", payload: false });
        } else {
          notification.warning({
            message: "Subscription failed!",
            description: `Your email could not be validated: ${email}`,
            placement: state.isMobile ? "bottom" : "topRight",
          });

          dispatch({ type: "SET_SUBSCRIBE_COMPLETED", payload: false });
        }
      });
    } else {
      notification.warning({
        message: "email error",
        description: `Your email does not appear to be valid: ${email}`,
        placement: state.isMobile ? "bottom" : "topRight",
      });

      dispatch({ type: "SET_SUBSCRIBE_COMPLETED", payload: false });
    }
  };

  return (
    <Input.Search
      style={{ maxWidth: "500px" }}
      placeholder="Enter your email"
      enterButton="Subscribe now"
      autoComplete="email"
      prefix={<MailOutlined />}
      onSearch={(value) => handleSubscribe(value)}
      disabled={state.subscribeCompleted}
    />
  );
};

export default SubscribeForm;
